<template>
    <ds-modal
        :is-open="isOpen"
        show-close
        :title="$t('funnel.edit.lightbox.saveAs')"
        size="sm"
        @close="closeMakeCopy"
    >
        <template #header>
            <ds-filled-button
                data-qa="make-copy-button"
                @click="makeCopy"
            >
                {{ $t('funnel.edit.save') }}
            </ds-filled-button>
        </template>

        <template #default>
            <ds-input-field
                v-model="funnelCopyName"
                :label="$t('funnel.edit.title')"
                data-qa="copy-name"
            />
        </template>
    </ds-modal>
</template>
<script>
import { makeCopy } from './makeCopy.api';

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        funnelId: {
            type: Number,
            default: 0,
        },
        funnelName: {
            type: String,
            required: true,
        },
        draftJson: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['close-make-copy'],
    data() {
        return {
            funnelCopyName: `${this.$t('funnel.campaign.action.copy.label')}${this.funnelName}`,
        };
    },

    methods: {
        async makeCopy() {
            try {
                const { data } = await makeCopy(this.funnelId, this.funnelCopyName, this.draftJson);

                this.$toast({ message: this.$t('funnel.campaign.action.copy.created.notify.message') });
                this.$emit('close-make-copy', true);

                window.location.href = `/app/funnel/funnelEditor?funnelId=${data}`;
            } catch (error) {
                this.$error({ message: this.$t('funnel.campaign.action.copy.error.notify.message') });
            }
        },

        closeMakeCopy() {
            this.$emit('close-make-copy', false);
        },
    },
};
</script>
